/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

export const APP_STATE = "WINTECHERP";
export const API = "/api";
export const DEBUG = false;
export const DEBUG_ID = "";
export const DEBUG_TOKEN = "";
export const DEBUG_NAME = "";
export const DEBUG_PIC = "";
export const DEBUG_STATUS = "";
export const DEBUG_EMAIL = "";

export const APP_NAME = "";
export const API_URL = "";

/* LINE LIFF */
export const LIFF_ID = "";
